import InAppSpy from 'inapp-spy';

export type EmbeddedBrowserInfo = {
  isEmbedded: boolean;
  appKey: string | null;
};

/** In-app browsers where Google/Apple OAuth is blocked — escape to system browser. */
const SOCIAL_IAB_APP_KEYS = new Set([
  'instagram',
  'facebook',
  'messenger',
  'threads',
  'tiktok',
  'twitter',
  'linkedin',
  'telegram',
  'whatsapp',
]);

export function detectEmbeddedBrowser(): EmbeddedBrowserInfo {
  try {
    const detection = InAppSpy();
    return {
      isEmbedded: Boolean(detection.isInApp),
      appKey: detection.appKey ?? null,
    };
  } catch {
    return { isEmbedded: false, appKey: null };
  }
}

/** True only for known social in-app browsers (avoids false positives on desktop Safari/Chrome). */
export function isSocialEmbeddedBrowser(): EmbeddedBrowserInfo {
  const detection = detectEmbeddedBrowser();
  if (!detection.isEmbedded || !detection.appKey) {
    return { isEmbedded: false, appKey: null };
  }
  if (!SOCIAL_IAB_APP_KEYS.has(detection.appKey)) {
    return { isEmbedded: false, appKey: null };
  }
  return detection;
}

export function buildAbsoluteAppUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${window.location.origin}${normalized}`;
}
